import React from "react";
import ReviewsTable from "../../UI/Reviews/ReviewsTable";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";

const Reviews = () => {
    return (
        <div>
            <PanelHead title="Reviews" />
            <PanelBody content={<ReviewsTable />} />
        </div>
    );
};

export default React.memo(Reviews);
